module.exports = __webpack_public_path__ + "static/media/HCMM688.04fd007c.jpg";